import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { useState } from "react";
import { classNames, formatDateWithTime } from "../../../../shared/utility";
import WipOutgoingSubTable2 from "./WipOutgoingSubTable2";
import TraceableBarcode from "../../../controls/TraceableBarcode";
import TraceableLotNumber from "../../../controls/TraceableLotNumber";

export default function WipOutgoingSubTable1(props) {
  const {
    data,
    outgoingLoadingRows,
    outgoingRowDetails,
    fetchOutgoingSubRowDetails,
    outgoingSubRowDetails,
    outgoingSubLoadingRows,
    openSlideForManufacturedItemDetails,
    onAskDeleteWipOutputItem,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!outgoingSubRowDetails[rowData.unique_id]) {
      fetchOutgoingSubRowDetails(rowData);
    }
  };

  const allowExpansion = (rowData) => {
    return rowData.pallet_id;
  };

  const singleItemActionTemplate = (rowData) => {
    return (
      <div>
        {rowData.deleted_at ? (
          <div>
            <p className="text-black font-bold text-lg">DELETED</p>
          </div>
        ) : (
          <div className="flex">
            {/* <button
              className={classNames(
                rowData.deleted_at
                  ? "hidden"
                  : "rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              )}
              onClick={() => {}}
            >
              Reprint
            </button> */}
            <button
              className="rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
              onClick={() => {
                openSlideForManufacturedItemDetails(rowData.id);
              }}
            >
              Info
            </button>
            <button
              className={classNames(
                rowData.deleted_at
                  ? "hidden"
                  : "ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
              )}
              onClick={() => onAskDeleteWipOutputItem(rowData)}
            >
              Delete
            </button>
          </div>
        )}
      </div>
    );
  };

  const bodyItemProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  function rowExpansionTemplate(data) {
    return (
      <WipOutgoingSubTable2
        data={data}
        outgoingSubLoadingRows={outgoingSubLoadingRows}
        outgoingSubRowDetails={outgoingSubRowDetails}
      />
    );
  }

  const bodyItemWeight = (item) => {
    return <p>{item.produced_net_kg} kg</p>;
  };

  const bodyItemPieces = (item) => {
    return <p>{item.produced_piece_count} pieces</p>;
  };

  const bodyFormatCreatedDate = (item) => {
    return <p>{formatDateWithTime(item.created_date)}</p>;
  };

  const itemCostInDollars = (item) => {
    return <p>${item.production_total_cost}</p>;
  };

  function barcodeLastNineDigits(rowData) {
    return (
      <TraceableBarcode
        barcode={rowData.barcode}
        displayValue={rowData.barcode.slice(-14)}
      />
    );
  }

  const lotNumberBody = (rowData) => (
    <TraceableLotNumber lotNumber={rowData.lot_number} traceType="manufactured" />
  );

  const cartonCountBody = (rowData) => {
    return <p>{rowData.total_cartons} cartons</p>;
  };

  if (outgoingLoadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = outgoingRowDetails[data.unique_id];
  if (!detail) return null;

  return (
    <div>
      <DataTable
        value={outgoingRowDetails[data.unique_id]}
        expandedRows={expandedRows}
        onRowToggle={(e) => {
          setExpandedRows(e.data);
        }}
        onRowExpand={onRowExpand}
        rowExpansionTemplate={rowExpansionTemplate}
        dataKey="unique_id"
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm wip-incoming-sub-items-table"
        cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2 text-sm inv-sub-item"
        selectionMode="checkbox"
      >
        <Column
          header="Product Name"
          body={bodyItemProductName}
          style={{ width: "23%" }}
        />
        <Column
          header="Lot Number"
          body={lotNumberBody}
          style={{ width: "10%" }}
        />
        <Column
          body={barcodeLastNineDigits}
          header="Barcode"
          style={{ width: "20%" }}
        />
        <Column
          field="created_by_name"
          header="Created by"
          style={{ width: "8%" }}
        />
        <Column
          header="Date added"
          body={bodyFormatCreatedDate}
          style={{ width: "12%" }}
        />
        <Column
          header="Carton Count"
          body={cartonCountBody}
          style={{ width: "12%" }}
        />
        <Column
          header="Total Weight"
          body={bodyItemWeight}
          style={{ width: "7%" }}
        />
        <Column
          header="Total Pieces"
          body={bodyItemPieces}
          style={{ width: "7%" }}
        />
        <Column header="Cost $" body={itemCostInDollars} />
        <Column body={singleItemActionTemplate} style={{ width: "19%" }} />
        <Column expander={allowExpansion} style={{ width: "6%" }} />
      </DataTable>
    </div>
  );
}
